import { Grid } from "@material-ui/core";
import { useEffect, useState } from "react";
import { Text } from "sunrise-ui";
import { displayDate } from "../../../utilities/displayDateUtils";



const MachineOverview = ({ machineData }: any) => {
    const [downTime, setDownTime] = useState('N/A');

    useEffect(() => {
        const totalDownTime = machineData?.totalDownTime ? machineData?.totalDownTime : 0;
        const days = Math.floor(totalDownTime / (60 * 60 * 24));
        const hours = Math.round(((totalDownTime % (60 * 60 * 24))) * 100 / (60 * 60)) / 100;
        if (days || hours)
            setDownTime(`${days} Days ${hours} hrs`);
        else
            setDownTime('N/A')
    }, [machineData])

    return (
        (<Grid className="d-flex bg--white box--shadow p1 mt1" xs={12}>
            <Grid item xs={12}>
                <Text
                    type="normal"
                    fonts="normal"
                    fontSize={14}
                    className="card-text mb1 mt0 fw400"
                >
                    <span>Average Diesel consumption/Hr</span>
                    <span className="ms1 float-right fw500">{machineData?.fuelConsumption}</span>
                </Text>
                <Text
                    type="normal"
                    fonts="normal"
                    fontSize={14}
                    className="card-text mb1 mt0 fw400"
                >
                    <span>Average Running Hrs per Day</span>
                    <span className="ms1 float-right fw500">{machineData?.avgRunningHoursPerDay}</span>
                </Text>
                <Text
                    type="normal"
                    fonts="normal"
                    fontSize={14}
                    className="card-text mb1 mt0 fw400"
                >
                    <span>Latest HMR Reading</span>
                    <span className="ms1 float-right fw500">{machineData?.hmr}</span>
                </Text>
                <Text
                    type="normal"
                    fonts="normal"
                    fontSize={14}
                    className="card-text mb1 mt0 fw400"
                >
                    <span>Machine Purchased/Hired on</span>
                    <span className="ms1 float-right fw500">{displayDate(machineData?.purchasedOrRentedOn)}</span>
                </Text>
                <Text
                    type="normal"
                    fonts="normal"
                    fontSize={14}
                    className="card-text mb1 mt0 fw400"
                >
                    <span>Machine Status</span>
                    <span className="ms1 float-right fw500 capitalize">{machineData?.ownership}</span>
                </Text>
                <Text
                    type="normal"
                    fonts="normal"
                    fontSize={14}
                    className="card-text mb1 mt0 fw400"
                >
                    <span>Total Down Time (Days)</span>
                    <span className="ms1 float-right fw500">{downTime}</span>
                </Text>
                <Text
                    type="normal"
                    fonts="normal"
                    fontSize={14}
                    className="card-text mb1 mt0 fw400"
                >
                    <span>Machinery Repair Cost (Rs)</span>
                    <span className="ms1 float-right fw500">{machineData?.repairCost}</span>
                </Text>
            </Grid>
        </Grid>)
    );
}

export default MachineOverview;